import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ArtefactType } from "src/models/models.model";
import { routes } from "src/constants/routes";

@Component({
  selector: "app-use-cases-card",
  //   imports: [
  //     CardChipsComponent,
  //     CardHeadingComponent,
  //     CardOwnerDetailComponent,
  //     CardActivitiesComponent,
  //     LastUpdatedDaysPipe,
  //     RouterLink,
  //     CommonModule,
  //   ],
  templateUrl: "./use-cases-card.component.html",
  styleUrls: ["./use-cases-card.component.scss"],
})
export class UseCasesCardComponent {
  readonly artefactType = ArtefactType;
  readonly routes = routes;
  userProfile: any;

  @Input() useCaseItem!: any;
  @Output() onViewUseCaseClick = new EventEmitter<any>();
  @Output() onBookmarkToggle = new EventEmitter<any>();
  @Output() onVoteButtonClicked = new EventEmitter<any>();

    constructor(private router: Router) {}

  ngOnInit() {
    // this.cachingService.loggedInUser.subscribe(({ user }) => {
    //   this.userProfile = user;
    // });
  }

  onError(event: Event, fallbackUrl: string = "") {
    (event.target as HTMLImageElement).src =
      fallbackUrl || "images/Avatars.svg";
  }

  onUseCaseClick(id: any) {
    this.router.navigate([`/admin/use-case/details/${id}`]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  //   toggleBookmark() {
  //     this.onBookmarkToggle.emit();
  //   }

  //   onVoteChange() {
  //     this.onVoteButtonClicked.emit();
  //   }
}
